export default "__VITE_ASSET__DVx7YfeK__"